(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ===== Toast ===== */
  var toastTimer;
  window.showToast = function (html) {
    var t = $('#toast'); if (!t) return;
    t.innerHTML = html; t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 3200);
  };

  /* ===== Mobile nav ===== */
  var mobileNav = $('#mobileNav');
  if (mobileNav) {
    var ham = $('#hamburger'), mc = $('#mobileClose');
    if (ham) ham.addEventListener('click', function () { mobileNav.classList.add('show'); });
    if (mc) mc.addEventListener('click', function () { mobileNav.classList.remove('show'); });
    $$('a', mobileNav).forEach(function (a) { a.addEventListener('click', function () { mobileNav.classList.remove('show'); }); });
  }

  /* ===== Cart drawer ===== */
  var drawer = $('#cartDrawer'), overlay = $('#cartOverlay');
  window.openCart = function () { if (drawer) { drawer.classList.add('show'); overlay.classList.add('show'); } };
  window.closeCart = function () { if (drawer) { drawer.classList.remove('show'); overlay.classList.remove('show'); } };

  var cartBtn = $('#cartBtn');
  // Let the cart icon open the drawer instead of navigating, if drawer exists
  if (cartBtn && drawer) {
    cartBtn.addEventListener('click', function (e) { e.preventDefault(); refreshCart(); openCart(); });
  }
  var cc = $('#cartClose'); if (cc) cc.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  function money(cents) {
    return '$' + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  window.refreshCart = function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = $('#cartItems');
        var count = $('#cartCount');
        if (count) count.textContent = cart.item_count;
        if (!items) return cart;
        if (cart.item_count === 0) {
          items.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
        } else {
          items.innerHTML = cart.items.map(function (it) {
            return '<div class="cart-item">' +
              '<img src="' + (it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1') : '') + '" alt="">' +
              '<div class="ci-info"><h4>' + it.product_title + '</h4>' +
              '<div class="ci-price">' + money(it.final_line_price) + '</div>' +
              '<button class="ci-remove" data-key="' + it.key + '">Remove</button></div></div>';
          }).join('');
        }
        var sub = $('#cartSubtotal'); if (sub) sub.textContent = money(cart.total_price);
        $$('.ci-remove', items).forEach(function (b) {
          b.addEventListener('click', function () { changeQty(b.getAttribute('data-key'), 0); });
        });
        return cart;
      });
  };

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCart(); });
  }

  /* AJAX add to cart — any form with [data-ajax-cart] */
  $$('form.js-ajax-cart').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          showToast('<strong>' + (item.product_title || 'Item') + '</strong> added to your cart');
          refreshCart(); openCart();
        })
        .catch(function () { showToast('Sorry — could not add that item.'); });
    });
  });

  // Initialize cart count on load
  if ($('#cartItems')) refreshCart();
})();
